import PropTypes from 'prop-types';

import themePropTypes from 'core/utils/prop-types/theme';

import withTheme from 'core/hocs/withTheme';

import Link from 'core/components/Link';
import ButtonWithIcon from 'core/components/ButtonWithIcon';

import ArrowStickRight from 'core/components/Icon/ArrowStickRight.svg';

import styles from './index.styl';


function GoToListBtn(props) {
  const {
    theme: {
      controls: {
        gameCompare: {
          leaderBoard: leaderBoardAtoms,
        },
      },
    },
    link,
    children,
  } = props;

  const Button = leaderBoardAtoms.button.siteButton || ButtonWithIcon;

  const ButtonIcon = () => (
    <span className={styles.icon}>
      <ArrowStickRight width={10} />
    </span>
  );

  return (
    <li className={styles.allBoard}>
      <style jsx>{`
        .ratings
          font ${leaderBoardAtoms.ratings}
      `}</style>
      <Link to={link}>
        <Button
          type={leaderBoardAtoms.buttonType}
          minWidth={213}
          className={styles.btn}
          {...!leaderBoardAtoms.button.siteButton &&
            { icon: ButtonIcon, iconPosition: 'right' }}
        >
          <span className='ratings'>{children}</span>
        </Button>
      </Link>
    </li>
  );
}

GoToListBtn.propTypes = {
  link: PropTypes.string,
  theme: themePropTypes(`
    {
      controls: {
        gameCompare: {
          leaderBoard: {
            button: {
              buttonType,
            },
          }
        }
      },
    },
  `),
};

export default withTheme(GoToListBtn);
